"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var model_1 = require("../../../model");
var widget_1 = require("../../../model/events/widget");
var safeSerializeObjRef_1 = require("../../../_staging/metadata/safeSerializeObjRef");
var DefaultDashboardKpiWidget_1 = require("./DefaultDashboardKpiWidget");
var InsightWidget_1 = require("./InsightWidget");
/**
 * @internal
 */
exports.DefaultDashboardWidget = react_1.default.memo(function DefaultDashboardWidget(props) {
    var onError = props.onError, onFiltersChange = props.onFiltersChange, screen = props.screen, widget = props.widget, backend = props.backend, 
    // @ts-expect-error Don't expose index prop on public interface (we need it only for css class for KD tests)
    index = props.index;
    if (!sdk_model_1.isDashboardWidget(widget)) {
        throw new sdk_backend_spi_1.UnexpectedError("Cannot render custom widget with DefaultWidgetRenderer! Please handle custom widget rendering in your widgetRenderer.");
    }
    var ref = sdk_model_1.widgetRef(widget);
    var dispatchEvent = model_1.useDashboardEventDispatch();
    var effectiveBackend = sdk_ui_1.useBackendStrict(backend);
    var backendWithEventing = react_1.useMemo(function () {
        // use a flag to report only the first result of the execution as per the events documented API
        var hasReportedResult = false;
        var onSuccess = function (dataView, executionId) {
            if (!hasReportedResult) {
                dispatchEvent(widget_1.widgetExecutionSucceeded(ref, dataView, executionId));
                hasReportedResult = true;
            }
        };
        var onError = function (error, executionId) {
            if (!hasReportedResult) {
                dispatchEvent(widget_1.widgetExecutionFailed(ref, sdk_ui_1.convertError(error), executionId));
                hasReportedResult = true;
            }
        };
        return sdk_backend_base_1.withEventing(effectiveBackend, {
            beforeExecute: function (def, executionId) {
                hasReportedResult = false;
                dispatchEvent(widget_1.widgetExecutionStarted(ref, def, executionId));
            },
            successfulResultReadAll: onSuccess,
            successfulResultReadWindow: function (_offset, _limit, dataView, executionId) {
                onSuccess(dataView, executionId);
            },
            failedExecute: onError,
            failedResultReadAll: onError,
            failedResultReadWindow: function (_offset, _limit, error, executionId) {
                onError(error, executionId);
            },
        });
    }, [effectiveBackend, dispatchEvent, safeSerializeObjRef_1.safeSerializeObjRef(ref)]);
    var dashboardItemClasses = "s-dash-item-" + index;
    if (sdk_model_1.isWidget(widget)) {
        return (react_1.default.createElement(sdk_ui_1.BackendProvider, { backend: backendWithEventing }, sdk_model_1.isInsightWidget(widget) ? (react_1.default.createElement(InsightWidget_1.RenderModeAwareDashboardInsightWidget, { widget: widget, screen: screen, dashboardItemClasses: dashboardItemClasses })) : (react_1.default.createElement(DefaultDashboardKpiWidget_1.DefaultDashboardKpiWidget, { kpiWidget: widget, screen: screen, dashboardItemClasses: dashboardItemClasses, onFiltersChange: onFiltersChange, onError: onError }))));
    }
    return react_1.default.createElement("div", null, "Unknown widget");
});
//# sourceMappingURL=DefaultDashboardWidget.js.map